<template>
  <div class="login">
    <div
      class="main"
      v-title
      data-title="中国美术学院-社会美术水平考级管理系统
"
    ></div>
    <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
      <el-tab-pane label="登录" name="login">
        <login-form></login-form>
      </el-tab-pane>
      <!-- <el-tab-pane label="注册" name="signup">
				<signup-form></signup-form>
			</el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import loginForm from "./components/loginForm";
import signupForm from "./components/signupForm";

export default {
  name: "login",
  data() {
    return { activeName: "login" };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
  },
  components: {
    loginForm,
    signupForm,
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 60%;
  max-width: 800px;
  margin: 0 auto;
  border: 1px solid #eee;
}
@media screen and (max-width: 768px) {
  .login {
    width: 90%;
  }
}
</style>
